import { Device } from "../Services/Device";
import { ConnectionStatus } from "../Models/DeviceConnectionStatus";
import { Led } from "@tblabs/truffle";


export class DeviceConnectionStatusIcon extends Led
{
    private invalidStateIcon = Led.White;
    private haltedStateIcon = Led.Blue;
    private statuses = {
        [ConnectionStatus.Unset]: { Icon: this.invalidStateIcon, Description: "Unset" },
        [ConnectionStatus.Offline]: { Icon: Led.White, Description: "Offline" },
        [ConnectionStatus.Connected]: { Icon: Led.Green, Description: "Connected" },
        [ConnectionStatus.ConnectError]: { Icon: Led.Red, Description: "Error" },
        [ConnectionStatus.Disconnected]: { Icon: Led.Brown, Description: "Disconnected" },
    };

    constructor(private device: Device)
    {
        super();
        this.Class("DeviceConnectionStatusIcon");

        device.ConnectionStatus.OnChange(() => this.Refresh());

        this.Refresh();
    }

    private Refresh()
    {
        const connectionStatus = this.device.ConnectionStatus.value;
        const isHalted = this.device.IsHalted;

        const color = (connectionStatus == ConnectionStatus.Connected) && isHalted
            ? this.haltedStateIcon
            : this.statuses[connectionStatus || ConnectionStatus.Unset]?.Icon || this.invalidStateIcon;
        // const description = this.statuses[connectionStatus]?.Description + (isHalted ? " and halted" : "");

        // this.Set(icon, description);
        this.SetColor(color);
    }
}
